module.exports = __webpack_public_path__ + "img/article6.dd60da68.png";